import isNil from 'lodash-es/isNil'

import { getFileType } from '../../../utils/file'
import { ArrowButton } from '../ArrowButton'
import { FilePreviewContainer } from '../FilePreviewContainer'
import {
  BUTTON_BACK,
  BUTTON_NEXT,
  PREVIEW_COMPONENT,
} from '../FilesPreviewGallery.constants'
import { useFilesPreviewGalleryNavigation } from '../FilesPreviewGallery.hooks'
import { GalleryHeader } from '../GalleryHeader'

import * as styles from '../FilesPreviewGallery.module.css'

function FilesPreviewGalleryContent({
  downloadFileDocument,
  files,
  getFileById,
  initActive,
  scope,
  subject,
  onClose,
}) {
  const { active, handleClickBack, handleClickNext } =
    useFilesPreviewGalleryNavigation(initActive)

  const file = files[active]

  const lastIndex = files.length - 1

  return isNil(file) ? null : (
    <>
      <GalleryHeader
        downloadFileDocument={downloadFileDocument}
        file={file}
        scope={scope}
        subject={subject}
        onClose={onClose}
      />
      <div className={styles.content}>
        <FilePreviewContainer
          Component={PREVIEW_COMPONENT[getFileType(file)]}
          downloadFileDocument={downloadFileDocument}
          file={file}
          getFileById={getFileById}
          scope={scope}
          subject={subject}
        />
      </div>
      {active !== 0 ? (
        <ArrowButton type={BUTTON_BACK} onClick={handleClickBack} />
      ) : null}
      {active !== lastIndex ? (
        <ArrowButton type={BUTTON_NEXT} onClick={handleClickNext} />
      ) : null}
    </>
  )
}

export default FilesPreviewGalleryContent
